/** Stable React key for ControlRenderer — must not include modal mode (view→edit is in-place). */
export function buildComposeControlRendererKey(
  actionId: string,
  formSessionKey: string,
  composeInstanceKey: string,
): string {
  return `${actionId}:${formSessionKey}:${composeInstanceKey}`;
}
